<template>
    <DisclaimerWindow />
    <div class="ctw-text-white ctw-text-center ctw-mt-10">
        <div class="ctw-w-full ctw-flex ctw-justify-center">
            <img v-if="avatarUrl" class="ctw-rounded-full ctw-mb-4" :src="avatarUrl" />
        </div>
        <div class="ctw-text-lg ctw-font-bold">{{messageHeadline}}</div>
        <div class="ctw-text-sm">{{message}}</div>
        <div class="ctw-text-xs ctw-mt-2 ctw-text-white48">
            {{disclaimerPrefix}} <span class="ctw-underline hover:ctw-text-white ctw-cursor-pointer" @click="toggleUsageNotes">{{disclaimerTitle}}</span>.
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWidgetStore } from '@/store/widget';
import DisclaimerWindow from './DisclaimerWindow.vue';

const widgetStore = useWidgetStore();

const avatarUrl = computed(() => widgetStore.bot.avatar_url);
const messageHeadline = computed(() => widgetStore.bot.messages.welcome_message_headline);
const message = computed(() => widgetStore.bot.messages.welcome_message);
// const disclaimerMessage = computed(() => widgetStore.bot.messages.disclaimer || 'Bitte beachten Sie unsere <a href="https://www.cierra.de/datenschutz/" target="_blank" class="ctw-text-white48 hover:ctw-text-white">Nutzungsbedingungen</a>.');

const toggleUsageNotes = () => {
    widgetStore.toggleDisclaimer();
}



const disclaimerPrefix = computed(() => widgetStore.bot.disclaimer.prefix || 'Bitte beachten Sie unsere');
const disclaimerTitle = computed(() => widgetStore.bot.disclaimer.title || 'Nutzungsbedingungen');
</script>